import type { TOC } from '@ember/component/template-only'
import { Tooltip } from 'teacher-ui-client/components/tooltip'
import { on } from '@ember/modifier'
import { t } from 'ember-intl'

interface Signature {
  Element: HTMLButtonElement
  Args: {
    bookInCollection: boolean
    onSelect: (event: Event) => void
    collectionName: string
    collectionBookCount: number
  }
}

export const CollectionSelectOption: TOC<Signature> = <template>
  <button
    type="button"
    class="flex w-full justify-between {{unless @bookInCollection 'hover:bg-dusty-black-50'}}"
    disabled={{@bookInCollection}}
    {{on "click" @onSelect}}
    ...attributes
  >
    <span>
      {{@collectionName}}
      {{#if @bookInCollection}}
        <Tooltip @text={{t "bookLibrary.components.collectionSelect.bookInCollectionTooltip"}} />
      {{/if}}
    </span>
    <span>
      {{t "bookLibrary.components.collectionSelect.numberOfBooks" count=@collectionBookCount}}
    </span>
  </button>
</template>
